import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.regexp.search";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "component-related-recommend",
    on: {
      "touchstart": function touchstart($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm.type == 1 && _vm.recommendList.length ? _c('div', {
    staticClass: "entrance-related-recommend"
  }, [_c('div', {
    staticClass: "txt-top"
  }, [_c('span', {
    staticClass: "cel-1"
  }, [_vm._v("套餐选择")]), _vm.recommendList.length > 2 ? _c('span', {
    staticClass: "cel-2",
    on: {
      "click": function click($event) {
        return _vm.slideUpMoreRecommend();
      }
    }
  }, [_vm._v("查看更多")]) : _vm._e()]), _c('div', {
    staticClass: "entrance-recommend-list"
  }, [_c('div', {
    staticClass: "recommend-item J_Report"
  }, [_c('div', {
    staticClass: "cel-left"
  }, [_c('p', {
    staticClass: "txt-p"
  }, [_vm._v("\n            " + _vm._s(_vm.product.isActivity ? _vm.product.activityName : _vm.product.goodsName) + "\n          ")])]), _c('div', {
    staticClass: "cel-right"
  }, [_c('div', {
    staticClass: "txt-price"
  }, [_c('span', {
    staticClass: "yuan"
  }, [_vm._v("￥")]), _c('span', {
    staticClass: "cel-2"
  }, [_vm._v(_vm._s(_vm.currentPrice.yuanText) + _vm._s(_vm.currentPrice.fenText.length > 0 ? "." + _vm.currentPrice.fenText : ""))]), _vm.product.isMultiPrice ? _c('span', {
    staticClass: "cel-3"
  }, [_vm._v("起")]) : _vm._e()]), _c('div', {
    staticClass: "current-btn"
  }, [_vm._v("已选")])])]), _vm._l(_vm.recommendList, function (recommend, index) {
    return [index === 0 || index === 1 ? _c('div', {
      key: recommend.goodsId,
      staticClass: "recommend-item J_Report",
      attrs: {
        "data-item_id": recommend.goodsId,
        "data-product_category": "product",
        "data-activity_id": recommend.isActivity ? recommend.activityId : ''
      },
      on: {
        "click": function click($event) {
          $event.stopPropagation();
          return _vm.goProductDetailPage(recommend);
        }
      }
    }, [_c('div', {
      staticClass: "cel-left",
      class: {
        'is-activity': recommend.isActivity
      }
    }, [_c('p', {
      staticClass: "txt-p"
    }, [_vm._v("\n              " + _vm._s(recommend.isActivity ? recommend.activityName : recommend.goodsName) + "\n            ")])]), _c('div', {
      staticClass: "cel-right"
    }, [_c('div', {
      staticClass: "txt-price"
    }, [_c('span', {
      staticClass: "yuan"
    }, [_vm._v("￥")]), _c('span', {
      staticClass: "cel-2"
    }, [_vm._v(_vm._s(recommend.minPrice))]), recommend.isMultiSpec ? _c('span', {
      staticClass: "cel-3"
    }, [_vm._v("起")]) : _vm._e()]), !_vm.isReviewing && _vm.isPromoter && _vm.getIsShow(recommend.sellComm + recommend.appSellComm) ? _c('div', {
      staticClass: "txt-commission"
    }, [_c('span', {
      staticClass: "cel-1"
    }, [_vm._v(_vm._s(_vm.isAPP ? "赚" : "省"))]), (recommend.appSellComm || recommend.sellComm).search(/[￥|¥]/) != -1 ? _c('span', {
      staticClass: "yuan"
    }, [_vm._v("¥")]) : _vm._e(), _c('span', {
      staticClass: "cel-3"
    }, [_vm._v(_vm._s(_vm._f("filterCommKeepOne")((recommend.appSellComm || recommend.sellComm).replace(/[￥|¥|%]/, ""))))]), (recommend.appSellComm || recommend.sellComm).search(/[%]/) != -1 ? _c('span', {
      staticClass: "cel-4"
    }, [_vm._v("\n                %\n              ")]) : _vm._e()]) : _vm._e()])]) : _vm._e()];
  })], 2)]) : _vm._e(), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showMoreRecommend,
      expression: "showMoreRecommend"
    }],
    staticClass: "Layer-FullScreen more-recommend-box",
    on: {
      "click": function click($event) {
        return _vm.slideDownMoreRecommend();
      }
    }
  }, [_c('div', {
    staticClass: "main-bottom",
    class: {
      'slide-down': _vm.moreRecommendSlideDown
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('p', {
    staticClass: "txt-h"
  }, [_c('span', [_vm._v("套餐选择")]), _c('i', {
    on: {
      "click": function click($event) {
        return _vm.slideDownMoreRecommend();
      }
    }
  })]), _c('div', {
    staticClass: "recommend-list"
  }, _vm._l(_vm.recommendList, function (recommend) {
    return _c('div', {
      key: recommend.goodsId,
      staticClass: "recommend-item J_Report",
      attrs: {
        "data-item_id": recommend.goodsId,
        "data-product_category": "product",
        "data-activity_id": recommend.isActivity ? recommend.activityId : ''
      },
      on: {
        "click": function click($event) {
          $event.stopPropagation();
          return _vm.goProductDetailPage(recommend);
        }
      }
    }, [_c('div', {
      staticClass: "cel-left",
      class: {
        'is-activity': recommend.isActivity
      }
    }, [_c('p', {
      staticClass: "txt-p"
    }, [_vm._v("\n              " + _vm._s(recommend.isActivity ? recommend.activityName : recommend.goodsName) + "\n            ")])]), _c('div', {
      staticClass: "cel-right"
    }, [_c('div', {
      staticClass: "txt-price"
    }, [_c('span', {
      staticClass: "cel-1"
    }, [_vm._v("¥")]), _c('span', {
      staticClass: "cel-2"
    }, [_vm._v(_vm._s(recommend.minPrice))]), recommend.isMultiSpec ? _c('span', {
      staticClass: "cel-3"
    }, [_vm._v("起")]) : _vm._e()]), !_vm.isReviewing && _vm.isPromoter && _vm.getIsShow(recommend.sellComm + recommend.appSellComm) ? _c('div', {
      staticClass: "txt-commission"
    }, [_c('span', {
      staticClass: "cel-1"
    }, [_vm._v(_vm._s(_vm.isAPP ? "赚" : "省"))]), (recommend.appSellComm || recommend.sellComm).search(/[￥|¥]/) != -1 ? _c('span', {
      staticClass: "yuan"
    }, [_vm._v("¥")]) : _vm._e(), _c('span', {
      staticClass: "cel-3"
    }, [_vm._v(_vm._s(_vm._f("filterCommKeepOne")((recommend.appSellComm || recommend.sellComm).replace(/[￥|¥|%]/, ""))))]), (recommend.appSellComm || recommend.sellComm).search(/[%]/) != -1 ? _c('span', {
      staticClass: "cel-4"
    }, [_vm._v("\n                %\n              ")]) : _vm._e()]) : _vm._e()])]);
  }), 0)])]), _vm.type == 2 ? _c('div', {
    staticClass: "good-offline-box"
  }, [_vm.recommendList.length ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showRecommendBox,
      expression: "showRecommendBox"
    }],
    staticClass: "Layer-FullScreen recommend-box",
    class: {
      'slide-down': _vm.recommendBoxSlideDown
    },
    on: {
      "click": _vm.slideDownRecommendBox
    }
  }, [_c('div', {
    staticClass: "main-bottom",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('p', {
    staticClass: "txt-h"
  }, [_c('span', [_vm._v("商品已抢光，为您推荐相关好去处")]), _c('i', {
    on: {
      "click": _vm.slideDownRecommendBox
    }
  })]), _c('div', {
    staticClass: "recommend-list"
  }, _vm._l(_vm.recommendList, function (recommend) {
    return _c('div', {
      key: recommend.goodsId,
      staticClass: "recommend-item J_Report",
      attrs: {
        "data-item_id": recommend.goodsId,
        "data-product_category": "product",
        "data-activity_id": recommend.isActivity ? recommend.activityId : ''
      },
      on: {
        "click": function click($event) {
          $event.stopPropagation();
          return _vm.goProductDetailPage(recommend);
        }
      }
    }, [_c('div', {
      staticClass: "cel-left",
      class: {
        'is-activity': recommend.isActivity
      }
    }, [_c('p', {
      staticClass: "txt-p"
    }, [_vm._v("\n                " + _vm._s(recommend.isActivity ? recommend.activityName : recommend.goodsName) + "\n              ")])]), _c('div', {
      staticClass: "cel-right"
    }, [_c('div', {
      staticClass: "txt-price"
    }, [_c('span', {
      staticClass: "cel-1"
    }, [_vm._v("￥")]), _c('span', {
      staticClass: "cel-2"
    }, [_vm._v(_vm._s(recommend.minPrice))]), recommend.isMultiSpec ? _c('span', {
      staticClass: "cel-3"
    }, [_vm._v("起")]) : _vm._e()]), !_vm.isReviewing && _vm.isPromoter && _vm.getIsShow(recommend.sellComm + recommend.appSellComm) ? _c('div', {
      staticClass: "txt-commission"
    }, [_c('span', {
      staticClass: "cel-1"
    }, [_vm._v(_vm._s(_vm.isAPP ? "赚" : "省"))]), (recommend.appSellComm || recommend.sellComm).search(/[￥|¥]/) != -1 ? _c('span', {
      staticClass: "cel-2"
    }, [_vm._v("¥")]) : _vm._e(), _c('span', {
      staticClass: "cel-3"
    }, [_vm._v(_vm._s(_vm._f("filterCommKeepOne")((recommend.appSellComm || recommend.sellComm).replace(/[￥|¥|%]/, ""))))]), (recommend.appSellComm || recommend.sellComm).search(/[%]/) != -1 ? _c('span', {
      staticClass: "cel-4"
    }, [_vm._v("%\n                ")]) : _vm._e()]) : _vm._e()])]);
  }), 0)])]) : _vm._e(), !_vm.isOtherBrowser && _vm.showOffline ? _c('div', {
    staticClass: "Layer-FullScreen noticeType-Bulletbox good-offline",
    class: {
      'show-animation': _vm.showOffline,
      'fade-out': _vm.showOutAnimation
    },
    on: {
      "click": _vm.hideBox
    }
  }, [_c('div', {
    staticClass: "main",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('p', {
    staticClass: "txt-p"
  }, [_vm._v("\n          " + _vm._s(_vm.isExpired ? "产品已经失效" : _vm.stockShow == 2 ? "商品售罄" : "活动结束") + "啦~看看其他商品？\n        ")]), _c('span', {
    staticClass: "btn-cancel",
    on: {
      "click": _vm.hideBox
    }
  }, [_vm._v("取消")]), _c('span', {
    staticClass: "btn-confirm",
    on: {
      "click": function click($event) {
        return _vm.goTicketListPage('500127');
      }
    }
  }, [_vm._v("看看其它商品")])])]) : _vm._e()]) : _vm._e()]);
};
var staticRenderFns = [];
export { render, staticRenderFns };